import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from './env';
import type { Database } from './supabase-types';

const supabaseUrl = env.supabaseUrl;
const supabaseAnonKey = env.supabaseAnonKey;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Supabase credentials not found. Authentication will be disabled. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env.local file.',
  );
}

let cachedClient: SupabaseClient | undefined;

function ensureSupabase(): SupabaseClient {
  if (cachedClient) {
    return cachedClient;
  }

  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error(
      'Supabase credentials are required. Please configure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.',
    );
  }

  cachedClient = createClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: false,
      detectSessionInUrl: true,
    },
  });

  return cachedClient;
}

export function getSupabase(): SupabaseClient {
  return ensureSupabase();
}

export const supabase: SupabaseClient = new Proxy({} as SupabaseClient, {
  get<P extends keyof SupabaseClient>(_target: SupabaseClient, property: P) {
    const client = ensureSupabase();
    return Reflect.get(client, property, client) as SupabaseClient[P];
  },
});
